import { useQuery } from "@tanstack/react-query";
import { getCustomerSupportFaqReadFaqHeaderapi } from "../../../../api/support/faq";

export const useGetCustomerSupportFaqReadFaqHeader = () => {
  return useQuery({
    queryKey: ["getCustomerSupportFaqReadFaqHeader"],
    queryFn: () => getCustomerSupportFaqReadFaqHeaderapi(),
    // staleTime: 6000 * 10,
    select: (res) => res?.result,
    retry: false,
  });
};
